import { Pipe, PipeTransform } from "@angular/core";
import { NameDto } from "app/api/models";

@Pipe({
    name: "filterEmployeesByEmployee",
    standalone: false
})
export class FilterEmployeesByEmployeePipe implements PipeTransform {
  transform(value?: NameDto[], selectedEmployeeId?: number): NameDto[] {
    if (!selectedEmployeeId) {
      return value;
    }
    return value?.filter(({ id }) => id !== selectedEmployeeId);
  }
}
